import { css, styled } from 'canoe';
import React from 'react';

import { FilteredComponents } from './FilteredComponents';

export const ComponentsColumns = styled.div`
  display: flex;
  height: 100%;
  max-height: calc(100% - 48px);
  overflow: hidden;
`;

export const StaticColumn = styled.div`
  ${({ theme }) => css`
    height: 100%;
    width: 138px;
    flex-shrink: 0;
    padding: ${theme.spaces.s} ${theme.spaces.xs};
  `}
`;
export const ScrollableColumn = styled.div`
  ${({ theme }) => css`
    height: 100%;
    flex: 1;
    background-color: ${theme.colors.GlitterGrayL20};
    padding-top: ${theme.spaces.s};
  `}
`;

export const ComponentsTab = React.memo(() => {
  return <FilteredComponents />;
});
